import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import React from "react";
import Summary from "./Summary";
import Shipment from "./Shipment";

function byNoShippingLast(a, b) {
  const typeA = a.hasNoShipping ? 1 : 0;
  const typeB = b.hasNoShipping ? 1 : 0;
  return typeA - typeB;
}

export default function Order({ order, refresh }) {
  return (
    <Box display="flex" flexDirection="column" gridGap="32px" maxWidth="1200px">
      <Summary order={order} />

      {(order.shipments || [])
        .slice()
        .sort(byNoShippingLast)
        .map((shipment, idx) => (
          <Shipment
            key={`${shipment.shipmentId}-${idx}`}
            order={order}
            shipmentNumber={idx + 1}
            shipment={shipment}
            hasMultipleShipments={order.shipments.length > 1}
            refresh={refresh}
          />
        ))}
    </Box>
  );
}

Order.propTypes = {
  order: PropTypes.shape({
    created: PropTypes.string.isRequired,
    receiptNumber: PropTypes.string.isRequired,
    receiptEmail: PropTypes.string.isRequired,
    shipments: PropTypes.arrayOf(
      PropTypes.shape({ shipmentId: PropTypes.string.isRequired }),
    ).isRequired,
  }).isRequired,
  refresh: PropTypes.func,
};
